import React, { useEffect, useContext } from 'react';
import '../../Styles/StartPage.scss';

//components
import LoginForm from './LoginForm';
import BrowserProtocolModal from '../console/GeneralModal';

//global state
import { StateContext, StateDispatchContext } from '../../AppStateContext';

//history
import { useHistory } from 'react-router';

//helper function
import {
  convertToHTTP,
  convertToHTTPS,
  connectToSelfHostedWeaviate,
} from '../../helperFunctions';

const StartPage = () => {
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  const history = useHistory();

  useEffect(() => {
    setState({
      ...state,
      clientId: '',
      oidcUri: '',
      isLoggedIn: false,
      isWeaviateAuthenticated: null,
      isWeaviateSelfHosted: null,
      currentModule: 'home',
      isWeaviateURIDisconnected: true,
      wcsUserEmail: '',
      isLogInSelfHostedIncorrect: false,
    });

    localStorage.setItem('refresh_token', JSON.stringify(''));
    localStorage.setItem('access_token', JSON.stringify(''));
    localStorage.setItem('isWeaviateAuthenticated', JSON.stringify(null));
    localStorage.setItem('isWeaviateSelfHosted', JSON.stringify(null));
    localStorage.setItem('isLoggedIn', JSON.stringify(false));
    localStorage.setItem('clientId', JSON.stringify(''));
    localStorage.setItem('oidcUri', JSON.stringify(''));
    localStorage.setItem('wcsUserEmail', JSON.stringify(''));
    localStorage.setItem('currentModule', JSON.stringify('home'));
    localStorage.setItem('isWeaviateURIDisconnected', JSON.stringify(true));
    localStorage.setItem('selfHostedWeaviateVersion', JSON.stringify(''));
    localStorage.setItem('hasSharedQuery', JSON.stringify(false));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const modalCancel = () => {
    setState({ ...state, isBrowserProtocolModalOpen: false });
  };

  const changeBrowserProtocol = () => {
    if (state.upgradeBrowserProtocol) {
      window.location = convertToHTTPS();
    } else {
      window.location = convertToHTTP();
    }
  };

  const keepCurrentProtocol = () => {
    setState(
      {
        ...state,
        keepCurrentProtocol: true,
        isBrowserProtocolModalOpen: false,
      },
      function () {
        return connectToSelfHostedWeaviate(history, setState, state);
      }
    );
  };

  return (
    <div className='__StartPage'>
      <div className='__card'>
        <LoginForm />
      </div>
      <BrowserProtocolModal
        title='Warning!'
        text={
          state.upgradeBrowserProtocol
            ? 'You are trying to connect to WCS using an unsecured HTTP protocol. Please upgrade to a secure HTTPS protocol to proceed'
            : "You are trying to connect to a Weaviate instance running on unsecured HTTP protocol. You may or may not need to downgrade to a HTTP protocol in order to proceed. Please chose how you'd like to proceed."
        }
        cancelFunction={modalCancel}
        closeModal={modalCancel}
        actionFunction={changeBrowserProtocol}
        actionText={state.upgradeBrowserProtocol ? 'Upgrade' : 'Downgrade'}
        cancelText='Cancel'
        modalDescription={'http/https warning modal dialog'}
        open={state.isBrowserProtocolModalOpen}
        noAction={!state.upgradeBrowserProtocol ? true : false}
        noActionText={state.upgradeBrowserProtocol ? '' : 'Stay on HTTPS'}
        noActionFunction={keepCurrentProtocol}
      />
    </div>
  );
};

export default StartPage;
